module.exports = __webpack_public_path__ + "img/injective-8.cc8193b8.webp";